import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryTabs from './components/CategoryTabs';
import FeaturedSection from './components/FeaturedSection';
import { movies, testimonials, faqItems } from '@/mocks/movies';

const hotMovies = movies.filter((m) => m.isHot);
const newMovies = movies.filter((m) => m.isNew);
const recommendedMovies = movies.filter((m) => m.isRecommended);

export default function Home() {
  const homepageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '91影视看片下载',
    url: 'https://www.91yingshi.com/',
    description: '91影视看片下载提供免费电影电视剧全集在线观看，天美麻花星空影视免费看、麻花星空影视免费观看，高清不缓冲，免费追剧平台每日更新最新资源。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://www.91yingshi.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
    inLanguage: 'zh-CN',
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '91影视看片下载',
    url: 'https://www.91yingshi.com/',
    description: '免费影视大全高清追剧平台',
    foundingDate: '2020',
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homepageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection />

          <div className="w-full px-4 md:px-6 -mt-20 relative z-20">
            <CategoryTabs />

            <FeaturedSection
              title="热门推荐"
              movies={hotMovies}
              viewAllLink="/category/all"
            />

            <FeaturedSection
              title="最新上线"
              movies={newMovies}
              viewAllLink="/category/all"
            />

            <FeaturedSection
              title="好评如潮"
              movies={recommendedMovies}
              viewAllLink="/category/all"
            />

            <section className="mb-14">
              <div className="flex items-center justify-between mb-6">
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">
                  用户口碑
                </h2>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                {testimonials.map((item, index) => (
                  <div
                    key={index}
                    className="p-5 rounded-lg bg-background-100 border border-background-200/50"
                  >
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: item.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-400 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-foreground-300 text-sm leading-relaxed mb-4">
                      &ldquo;{item.content}&rdquo;
                    </p>
                    <div className="flex items-center gap-3">
                      <img
                        src={item.avatar}
                        alt={item.name}
                        className="w-9 h-9 rounded-full object-cover"
                        title={item.name}
                      />
                      <span className="text-foreground-200 text-sm font-medium">{item.name}</span>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-14">
              <div className="flex items-center justify-between mb-6">
                <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">
                  常见问题
                </h2>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {faqItems.map((item, index) => (
                  <div
                    key={index}
                    className="p-5 rounded-lg bg-background-100 border border-background-200/50"
                  >
                    <h4 className="font-heading text-foreground-100 font-semibold mb-2">
                      {item.question}
                    </h4>
                    <p className="text-foreground-400 text-sm leading-relaxed">
                      {item.answer}
                    </p>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-14">
              <div className="p-8 md:p-12 rounded-xl bg-gradient-to-r from-primary-600/30 via-primary-500/20 to-accent-600/20 border border-primary-500/20 text-center">
                <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
                  天美麻花星空影视免费观看电视
                </h2>
                <p className="text-foreground-300 text-sm md:text-base max-w-2xl mx-auto mb-6">
                  每天更新最新影视资源，高清不缓冲，让您畅享无限观影乐趣。无需注册，打开即看！
                </p>
                <a
                  href="/category/all"
                  className="inline-flex items-center gap-2 px-8 py-3 rounded-full bg-primary-500 text-foreground-50 font-semibold hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap"
                >
                  <i className="ri-movie-line"></i>
                  开始免费观影
                </a>
              </div>
            </section>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
}